import React from 'react';
import cn from 'classnames';

import './liveLabel.scss';

interface Props {
    isFaded?: boolean;
}

// TODO: add "title"
const LiveLabel: React.FC<Props> = ({ isFaded }) => {
    return (
        <div
            styleName={cn('live', { 'is-faded': isFaded })}
            className="__app-LiveLabel"
        >
            Live
        </div>
    );
};

export default LiveLabel;
